
import { Vue, Component, Prop } from "vue-property-decorator";
import { FormField } from "@/service/common/form/FormModel";
@Component
export default class IconError extends Vue {
  @Prop() field!: FormField;
}
